import { Button } from '@e2n/ui';
import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useAnlageassistentContext } from '@/domain/mitarbeiter/features/anlageassistent/context/useAnlageassistentContext';
import { faPenToSquare } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Persoenliches() {
  const { t } = useTranslation();
  const { ctx } = useAnlageassistentContext();
  const form = useAnlageassistentFormContext();

  const data = form.state.values;

  return (
    <div className="flex flex-col gap-2">
      <div className="flex gap-2 items-center justify-between">
        <h2 className="text-neutrals-900 text-xl font-bold leading-7 wrap-break-word">
          {`${data.person.persoenliches.vorname} ${data.person.persoenliches.nachname}`}
        </h2>
        <Button variant={'icon'} onClick={() => ctx.navigateToStep('person')}>
          <FontAwesomeIcon
            icon={faPenToSquare}
            className="text-primary-blue-600"
          />
        </Button>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-neutrals-800 text-sm font-normal leading-5">
          {t('domain.mitarbeiter.create.allgemeinForm.anrede.label')}
        </span>
        <span className="text-neutrals-900 text-sm font-semibold leading-5">
          {data.person.persoenliches.anrede}
        </span>
      </div>
      <div className="flex flex-col gap-1">
        <span className="text-neutrals-800 text-sm font-normal leading-5">
          {t(
            'domain.mitarbeiter.create.steps.person.persoenliches.form.rufname.label',
          )}
        </span>
        <span className="text-neutrals-900 text-sm font-semibold leading-5">
          {data.person.persoenliches.rufname || '-'}
        </span>
      </div>
      <div className="grid grid-cols-2 gap-4 wrap-anywhere">
        <div className="flex flex-col gap-1 border border-neutrals-300 rounded-lg p-3">
          <span className="text-neutrals-800 text-sm font-normal leading-5">
            {t(
              'domain.mitarbeiter.create.steps.person.persoenliches.form.personalnummer.label',
            )}
          </span>
          <span className="text-neutrals-900 text-sm font-semibold leading-5">
            {data.person.persoenliches.personalnummer || '-'}
          </span>
        </div>
        <div className="flex flex-col gap-1 border border-neutrals-300 rounded-lg p-3">
          <span className="text-neutrals-800 text-sm font-normal leading-5">
            {t(
              'domain.mitarbeiter.create.steps.person.persoenliches.form.e2nId.label',
            )}
          </span>
          <span className="text-neutrals-900 text-sm font-semibold leading-5">
            {data.person.persoenliches.e2nId || '-'}
          </span>
        </div>
      </div>
    </div>
  );
}
